"use strict";
/**
 * Safety Assessment Types for ARP4761A
 *
 * Comprehensive type definitions for:
 * - SFHA (System Functional Hazard Assessment)
 * - FTA (Fault Tree Analysis)
 * - FMEA (Failure Modes and Effects Analysis)
 * - CMA (Common Mode Analysis)
 * - ZSA (Zonal Safety Analysis)
 * - DD (Dependence Diagrams)
 * - MA (Markov Analysis)
 *
 * These types support the complete ARP4761A SSA workflow with
 * full traceability to reliability data sources.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROBABILITY_OBJECTIVES = void 0;
exports.getProbabilityObjective = getProbabilityObjective;
exports.classifySeverity = classifySeverity;
exports.generateSafetyId = generateSafetyId;
exports.meetsProbabilityObjective = meetsProbabilityObjective;
/**
 * Probability objectives per severity (per flight hour)
 */
exports.PROBABILITY_OBJECTIVES = {
    'Catastrophic': 1.0e-9,
    'Hazardous': 1.0e-7,
    'Major': 1.0e-5,
    'Minor': 1.0e-3,
    'No_Safety_Effect': Infinity,
};
// ===== Utility Functions =====
/**
 * Get the probability objective for a severity classification
 */
function getProbabilityObjective(severity) {
    return exports.PROBABILITY_OBJECTIVES[severity];
}
/**
 * Classify severity based on effects
 */
function classifySeverity(preventsSafeFlight, safetyMarginReduction) {
    if (preventsSafeFlight)
        return 'Catastrophic';
    switch (safetyMarginReduction) {
        case 'complete':
        case 'large':
            return 'Hazardous';
        case 'significant':
            return 'Major';
        case 'slight':
            return 'Minor';
        case 'none':
        default:
            return 'No_Safety_Effect';
    }
}
/**
 * Generate a unique ID for safety elements
 */
function generateSafetyId(prefix) {
    const timestamp = Date.now().toString(36);
    const random = Math.random().toString(36).substring(2, 6);
    return `${prefix}-${timestamp}-${random}`;
}
/**
 * Check if a probability meets the objective for a severity
 */
function meetsProbabilityObjective(probability, severity) {
    return probability <= exports.PROBABILITY_OBJECTIVES[severity];
}
//# sourceMappingURL=safety.js.map